import { HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { IOrganisationNotificationCountItem } from 'cde-fe-organization-registration-dialog';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '@cde-fe-app/environments/environment';
import { INotificationParams, PaginatedNotifications } from './../models/notification.model';
import { ServiceCall } from './service-call.service';

@Injectable()
export class NotificationsService {
  private serviceCall = inject(ServiceCall);
  private notificationsUrlV2 = `${environment.apiBaseUrl}/v2/notifications`;
  private lastVisitUrlV2 = `${environment.apiBaseUrl}/v2/last-visit`;

  getNotifications(params: INotificationParams | undefined): Observable<PaginatedNotifications> {
    const sort = params?.sort && params.sort.length ? params.sort.join() : ['notificationDate', 'desc'].join();

    const reqParams = new HttpParams({
      fromObject: {
        ...(params?.page && params.page > -1 && { page: params.page.toString() }),
        ...(params?.size && params.size > -1 && { size: params.size.toString() }),
        ...{ sort: sort },
        ...(params?.language && { language: params.language }),
      },
    });

    return this.serviceCall.get(`${this.notificationsUrlV2}`, reqParams).pipe(map(response => response.data));
  }

  getCountForOrganisations() {
    return this.serviceCall
      .get(`${this.notificationsUrlV2}/per-user-counts`)
      .pipe(map(response => response.data.content as IOrganisationNotificationCountItem[]));
  }

  updateLastVisitToNotification() {
    const curentTime = new Date().toISOString();
    return this.serviceCall.put(this.lastVisitUrlV2, { lastVisit: curentTime });
  }
}
